module.exports = __webpack_public_path__ + "static/media/sponsorBanner@3x.6809098c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/sponsorBanner@3x.png
// module id = 621
// module chunks = 0